<template>
    <div class="warning_box">
      <div class="warning_center">
      <!-- 标题部分 -->
          <div class="warning_title"> 告警中心 <span @click="closeWarningCenter">×</span></div>
  
          <!-- 内容部分 -->
          <div class="warning_inner">
              <!-- 左边告警信息 -->
              <!-- <div class="warning_inner_left">
                  <div class="warning_record">
                      <div class="warning_record_item" v-for="(item,index) in warningRecord" :key="index">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <div class="item_left">
                              <i class="iconfont" :class="item.icon"></i>
                              <span>{{ item.text }}</span>
                          </div>
                          <div class="item_right">{{ item.num }}</div>
                      </div>
                  </div>
              </div> -->

              <!-- 右边查询 -->
            <div class="warning_inner_right">
                <!-- 上边下拉框个按钮 -->
                <div class="top_select">
                <!-- 下拉选择框 --> 
                    <div class="top_select_left">
                    <!-- 模糊查询 -->
                    <div class="select_item">
                        <label>关键字</label>
                        <el-input class="stationName" placeholder="请输入搜索关键字" v-model="keywordVal" maxLength="20" clearable></el-input>
                    </div>

                    <!-- 电站选择 -->
                    <div class="select_item">
                        <label>电站名称</label>
                        <el-select class="stationName" v-model="stationSelVal" @change="stationChange" placeholder="请选择">
                            <el-option
                            v-for="item1 in stationList"
                            :key="item1.id"
                            :label="item1.stationName"
                            :value="item1.id">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 控制器选择 -->
                    <div class="select_item">
                        <label>控制器</label>
                        <el-select class="stationName" v-model="ctrlSelVal" @change="ctrlChange" placeholder="请选择" clearable>
                            <el-option
                            v-for="item1 in ctrlList"
                            :key="item1.id"
                            :label="item1.ctlName"
                            :value="item1.id">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 设备选择 -->
                    <div class="select_item">
                        <label>设备名称</label>
                        <el-select class="stationName" v-model="devSelVal" placeholder="请选择" clearable>
                            <el-option
                            v-for="item1 in devList"
                            :key="item1.id"
                            :label="item1.devName"
                            :value="item1.id">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 状态选择 -->
                    <div class="select_item">
                        <label>状态标记</label>
                        <el-select class="stationName" v-model="stateSignSelVal" @change="stateSignChange"  multiple placeholder="请选择">
                            <el-option
                            v-for="item1 in stateSignList"
                            :key="item1.infoCode"
                            :label="item1.infoName"
                            :value="item1.infoCode">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 确认状态 -->
                    <div class="select_item">
                        <label>确认状态</label>
                        <el-select class="stationName" v-model="ConfirmStateSelVal" placeholder="请选择" clearable>
                            <el-option
                            v-for="item1 in ConfirmStateList"
                            :key="item1.infoCode"
                            :label="item1.infoName"
                            :value="item1.infoCode">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 开始时间 -->
                    <div class="select_item">
                        <label>开始时间</label>
                        <el-date-picker class="stationName" v-model="startDate" type="datetime" placeholder="日期选择"
                              value-format="timestamp" placement="bottom-start"></el-date-picker>
                    </div>

                    <!-- 结束时间 -->
                    <div class="select_item">
                        <label>结束时间</label>
                        <el-date-picker class="stationName" v-model="endDate" type="datetime" placeholder="日期选择"
                              value-format="timestamp" placement="bottom-start"></el-date-picker>
                    </div>

                    </div>
                    <!-- 提交按钮 -->
                    <div class="select_btn">
                        <button @click="searchWarningInfo"><i class="iconfont icon-sousuo"></i> 搜索</button>
                        <button @click="searchAll"><i class="iconfont icon-chakan"></i>查看所有</button>
                    </div>
                </div>

                <!-- 翻页器 -->
                <div class="pagination_div pagination_alarm">
                    <el-pagination background class="el_pag"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-size="pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="pageTotal">
                    </el-pagination>
                </div>

                  <!-- 数据表格 -->
                <div class="list_box">
                    <el-table :data="dataList" class="my_el_table" 
                                border
                                style="width: 100%; height:100%"
                                v-loading="loading"  
                                element-loading-text = "加载中，请稍后..."
                                element-loading-background = "#00151b">
                        <el-table-column label="ID" prop="id" width=""  show-overflow-tooltip></el-table-column>
                        <el-table-column label="数据时间" width=""  show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ longToDate(scope.row.dataTimeInt) }}</span>
                            </template>>
                        </el-table-column>
                        <el-table-column label="设备名称" prop="devNameNew"  width="" show-overflow-tooltip></el-table-column>
                        <el-table-column label="Key" prop="dataKey" width=""  show-overflow-tooltip></el-table-column>
                        <el-table-column label="数据名称" prop="dataNameNew" width=""  show-overflow-tooltip></el-table-column>
                        <el-table-column label="Value" prop="value" width="" show-overflow-tooltip></el-table-column>
                        <el-table-column label="Bit索引" prop="bitIndex" width="" show-overflow-tooltip></el-table-column>
                        <el-table-column label="告警信息" prop="bitInfo" width="" show-overflow-tooltip></el-table-column>
                        <el-table-column label="状态标记" prop="stateSignStr" width="" show-overflow-tooltip></el-table-column>
                        <el-table-column label="确认状态" prop="confirmStateStr" width="" show-overflow-tooltip></el-table-column>
                        <el-table-column label="自动消除时间"  width="" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ longToDate(scope.row.clearTimeInt) }}</span>
                            </template>>
                        </el-table-column>
                        <el-table-column label="操作" width="110">
                            <template slot-scope="scope">
                                <button class="button_style2 " @click="detailsClick(scope.row.id)">详情</button>
                                <i class="iconfont icon-vertical_line operation_line"></i>
                                <button class="button_style2 " @click="confirmClick(scope.row.id, scope.row)"> 确认 </button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
           
          </div>
      </div>

      <!-- 详情弹窗 -->
        <el-dialog :visible.sync="dialogTableVisible" :close-on-click-modal="false" :close-on-press-escape="false"  :append-to-body="true">
            <div slot="title" class="dialog_title">{{ dialog.title }}</div>
            <div class="dialog_content">
                <el-form  :model="dialog.elForm">
                    <el-form-item label="系统控制器名" prop="ctrlNameNew" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.ctrlNameNew"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="系统设备名称" prop="devNameNew" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.devNameNew"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="接收设备名称" prop="devName" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.devName"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="点表数据key" prop="dataKey" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.dataKey"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="点表数据索引" prop="dataIndex" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.dataIndex"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="系统数据名称" prop="dataNameNew" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.dataNameNew"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="接受数据名称" prop="dataName" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.dataName"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="生数据" prop="rawValue" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.rawValue"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="熟数据" prop="value" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.value"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="状态位索引" prop="bitIndex" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.bitIndex"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="状态位信息" prop="bitInfo" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.bitInfo"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="状态标记" prop="stateSign" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.stateSignStr"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="数据时间" prop="dataTimeInt" label-width="17rem">
                        <el-input
                            :value="longToDate(dialog.elForm.dataTimeInt)"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="自动消除时间" prop="cleartimeInt" label-width="17rem">
                        <el-input
                            :value="longToDate(dialog.elForm.cleartimeInt)"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="添加时间" prop="addTimeInt" label-width="17rem">
                        <el-input
                            :value="longToDate(dialog.elForm.addTimeInt)"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="确认状态" prop="confirmState" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.confirmStateStr"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="确认用户" prop="confirmUser" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.confirmUser"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="确认时间" prop="confirmTimeInt" label-width="17rem">
                        <el-input
                            :value="longToDate(dialog.elForm.confirmTimeInt)"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="确认说明" prop="confirmRemark" label-width="17rem">
                        <el-input
                            v-model="dialog.elForm.confirmRemark"
                            maxlength="20"
                            placeholder="请输入内容"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog_footer">
                <button class="button_style0" @click="dialogTableVisible=false"><i class="iconfont icon-tijiao"></i>确认</button>
            </div>
        </el-dialog>
    </div>
  </template>
  <script>
  import {mapState, mapMutations} from "vuex"
  import fun from "../../util/util";
  import myApi from "../../util/my-api";
  import myConst from "../../util/my-const";
  export default {  
      data(){     
          return {
              warningRecord:[
                  {
                      icon: "icon-gaojingjilu",
                      text: "告警记录数",
                      num: 10
                  },
                  {
                      icon: "icon-gaojingjilu",
                      text: "告警记录数",
                      num: 10
                  },
                  {
                      icon: "icon-gaojingjilu",
                      text: "告警记录数",
                      num: 10
                  },
                  {
                      icon: "icon-gaojingjilu",
                      text: "告警记录数",
                      num: 10
                  },
                  {
                      icon: "icon-gaojingjilu",
                      text: "告警记录数",
                      num: 10
                  },
                  {
                      icon: "icon-tishi",
                      text: "发生告警记录数",
                      num: 10
                  },
                  {
                      icon: "icon-shebeiliebiao",
                      text: "设备总数",
                      num: 10
                  },
                  {
                      icon: "icon-taizhanguzhang",
                      text: "故障设备数",
                      num: 10
                  },
                  {
                      icon: "icon-jilu",
                      text: "未确认记录数",
                      num: 10
                  },
                  {
                      icon: "icon-jilu",
                      text: "未确认记录数",
                      num: 10
                  },
                  {
                      icon: "icon-shijian",
                      text: "最早记录时间",
                      num: "2023/3/30 16:58"
                  },
                  {
                      icon: "icon-shijian",
                      text: "最晚记录时间",
                      num: "2023/3/30 16:58"
                  },
              ],
              dataList:[{id:1}],
              keywordVal:"",//关键字
              stationList:[], //电站列表
              stationSelVal:"", //电站选择内容
              ctrlList:[],//控制器
              ctrlSelVal:"",//控制器选择内容
              devList: [],  //设备
              devSelVal: '',
              stateSignList:[],//状态列表
              stateSignSelVal:['0'],//状态列表选择内容
              ConfirmStateList:[],//确认状态列表
              ConfirmStateSelVal:"",//确认状态选择事件
              startDate:"",//开始时间
              endDate:"",//结束时间
              currentPage: 1,  //当前页数
              pageSize: 150,  //每页条数
              pageTotal: 0,  //记录总数
              loading:false,
              dialogTableVisible:false, //确认弹出框
              defaultLoad:true, //首次进入加载实时报警数据列表
              dialog:{
                title:"",
                elForm:{
                    ctrlNameNew:"", //系统控制名
                    devNameNew:"" , //系统设备名称
                    devName:"", //接受设备名称
                    dataKey:"", //点表数据key,
                    dataIndex:"",//点表数据索引
                    dataNameNew:"",//系统数据名称
                    dataName:"",//接收数据名称
                    rawValue:"", //生数据
                    value:"", //熟数据
                    bitIndex:"", //状态位索引
                    bitInfo:"",//状态位信息
                    stateSign:"", //状态标记
                    dataTimeInt:"", //数据时间
                    cleartimeInt:"", //自动消除时间
                    addTimeInt:"", //添加时间
                    confirmState:"",//确认状态
                    confirmUser:"", //确认用户
                    confirmTimeInt:"", //确认时间
                    confirmRemark:"" ,//确认说明
                }
              }
  
          }
      },
      computed: {
      ...mapState("controlPopover",['showWarningCenter']),
      ...mapState("statMenu", ["statId"]),
  
      },
      mounted(){
          this.selectStationList() //获取电站列表
          this.loadStateSignList()//获取状态标价
          this.loadConfirmState() //获取确认状态
      },
      methods:{
          ...mapMutations("controlPopover",["closeWarning"]),

          //转化日期格式
          longToDate(val) {
            return fun.longToDate(val);
            },

          //查询电站集合
          async selectStationList() {
          let _this = this;
          await this.$axios.get(myApi.getPermissionStation).then(res => {
              if (res.data.code === myConst.code.success) {
              _this.stationList = res.data.data;
  
              if (_this.stationList.length > 0) {
                if(fun.isNull(this.statId)){
                    _this.stationSelVal = _this.stationList[0].id;
                } else {
                    _this.stationSelVal = this.statId
                }
                  
                  if(this.defaultLoad){
                    this.searchWarningInfo()
                    this.defaultLoad=false
                  }
                  _this.stationChange();
              }
              } else {
              _this.stationList = [];
              _this.stationSelVal = '';
              }
          }).catch(() => {
              //请求异常
              _this.stationList = [];
              _this.stationSelVal = '';
          });
          },
  
          //电站选择事件
          stationChange() {
              if (fun.isNull(this.stationSelVal)) {
                  return;
              } else {
                let _this = this;
                this.loadControlList()
                this.$axios.get(myApi.devGetListByStaId +  "?stationId=" + this.stationSelVal).then(res => {
                    if (res.data.code === myConst.code.success) {
                    _this.devList = res.data.data;
                    } else {
                    _this.devList = [];
                    _this.devSelVal = '';
                    }
                }).catch(() => {
                    //请求异常
                    _this.devList = [];
                    _this.devSelVal = '';
                });
              }
              
          },

          //控制器选择事件
          ctrlChange(){

          },

          //状态标记选择事件
          stateSignChange(){
            // console.log(this.stateSignSelVal);
          },

          //查询控制器列表
         loadControlList(){
            if(fun.isNull(this.stationSelVal)){
                this.$message({message:"请选择一个电站", type:"info"})
            } else {
                let data ={
                staId: this.stationSelVal,
                }
                this.$axios.post(myApi.getControlList, data).then(res=>{
                if(res.data.code === myConst.code.success){
                    this.ctrlList = res.data.data
                } else {
                    this.ctrlList = []
                }
                }).catch(()=>{ this.loading=false})
            }
         },

          //获取状态标记
          loadStateSignList(){
            this.$axios.get(myApi.getAlarmStateSign).then(res=>{
                if(res.data.code === myConst.code.success){
                    this.stateSignList = res.data.data
                } else {
                    this.stateSignList = []
                }
            })
          },

          //获取确认状态
          loadConfirmState(){
            this.$axios.get(myApi.getConfirmState).then(res=>{
                if(res.data.code === myConst.code.success){
                    this.ConfirmStateList = res.data.data
                } else {
                    this.ConfirmStateList = []
                }
            })
          },

          // 关闭告警弹窗
          closeWarningCenter(){
            this.closeWarning()
          },

          // 搜索按钮
          searchWarningInfo(){
            let data = {
                staId:this.stationSelVal,
                pageIndex:this.currentPage,
                pageSize:this.pageSize,
                keyword:this.keywordVal,
                ctrlId:this.ctrlSelVal,
                devId:this.devSelVal,
                stateSignList:this.stateSignSelVal,
                startDataTime:this.startDate,
                endDataTime:this.endDate,
                confirmState:this.ConfirmStateSelVal
            }
            this.loading = true
            this.$axios.post(myApi.getRealAlarmList,data).then(res=>{
                if(res.data.code === myConst.code.success){
                    this.dataList = res.data.data.list
                    this.pageTotal = res.data.data.total
                    this.loading = false
                } else {
                    // this.$message({ message:res.data.msg, type: "info"})
                    this.dataList = []
                    this.loading = false
                }
            }).catch(()=>{this.loading = false})
          },

          // 查看所有
          searchAll(){
            this.keywordVal = "",
            this.ctrlSelVal = "",
            this.devSelVal = "",
            this.stateSignSelVal = [],
            this.startDate = "",
            this.endDate = "",
            this.ConfirmStateSelVal = ""
            this.searchWarningInfo()
          },

          //翻页器
          handleCurrentChange(val){
            this.currentPage = val
            this.searchWarningInfo()
          },

          //根据id查询一条信息
          loadOneInfo(id){
            this.$axios.get(myApi.getOneRealAlarmInfo + "?id=" + id).then(res=>{
                if(res.data.code === myConst.code.success){ 
                    this.dialog.elForm = res.data.data;

                } else {
                    // this.$message({message:res.data.msg, type:"info"})
                    this.dialog.elForm = {}
                    this.dialog.elForm = {confirmTimeInt: '2023-09-08T06:30:54.000+00:00'}
                }
            }).catch(()=>{})
          },

          //表格确认按钮
          confirmClick(val,obj){
            //如果当前告警信息已经确认,那么将不再进行确认操作
            if(obj.confirmState == myConst.confirmState.confirm){
               this.$message({message:"已经确认过啦~"})
            } else {
                this.$prompt("请输入确认说明", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'textarea',
                }).then(res=>{
                    let data = {
                        id: val,
                        confirmRemark: res.value,
                    }
                    this.$axios.post(myApi.alarmConfirm, data).then(res=>{
                        if(res.data.code === myConst.code.success){
                            this.$message({message:res.data.data, type:"success"})
                            this.searchWarningInfo()
                        } else {
                            // this.$message({message:res.data.msg, type:"info"})
                        }
                    }).catch(()=>{})
                }).catch(()=>{})
            }
            
          },

          //表格详情按钮
          detailsClick(val){
            this.dialog.title = "详情"
            this.dialogTableVisible = true
            this.loadOneInfo(val)
          },
      },
  }
  </script>
  
  <style scoped>
  
  .warning_box{
      width: 100%;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
  
  }
  .warning_center{
      width: 135rem;
      height: 80rem;
      position: relative;
      left: 50%;
      margin-left: -67.5rem;
      top: 50%;
      margin-top: -40rem;
      background: url("../../assets/images/iems/control_win_bag.png") no-repeat center/100%;
      overflow: hidden;
      box-sizing: border-box;
      
  }
  .warning_title{
      padding-top: 0.7rem;
      height: 5.5%;
      width: 100%;
      color: #000F21;
      font-size: 1.8rem;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;
  }
  .warning_title>span{
      position: absolute;
      display: flex;
      right: 1.5%;
      width: 14px;
      height: 14px;
      font-size: 2.2rem;
      color:#00DAFC;
      cursor: pointer;
  }
  /* 内容部分 */
  .warning_inner{
      width: 100%;
      height: 94.5%;
      padding: 1% 1% 2% 1%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
  }
  /* 左边 */
  .warning_inner_left{
      width: 20%;
      height: 100%;
      background: #071d30;
      border: 1px solid #005469;
      overflow: hidden;
      padding:0  1rem ;
      box-sizing: border-box;
      border: solid 1px #0386a2;
      background-color:#001420;
      clip-path: polygon(15px 0, calc(100% - 15px) 0,100% 15px, 100% calc(100% - 15px),
                      calc(100% - 15px) 100%, 15px 100%,0 calc(100% - 15px),0 15px);
      background:linear-gradient(-45deg,#0386a2 10px, #001420 0) bottom right,
                 linear-gradient(45deg,#0386a2 10px, #001420 0) bottom left,
                 linear-gradient(135deg,#0386a2 10px, #001420 0) top left,
                 linear-gradient(-135deg,#0386a2 10px,#001420 0) top right; 
      background-size: 50% 50%; 
      background-repeat: no-repeat; 
      display: flex;
      flex-direction: row;
  }
  .warning_record{
      width: 100%;
      height: 92%;
      padding: 0.5rem 0.7rem ;
      box-sizing: border-box;
      margin: 2rem 0;
      overflow: auto;
  }
  .top_select_left{
    display: flex;
    flex-wrap: wrap;
    width: 85%;
  }
  .warning_record>.warning_record_item{
      border: 0.15rem solid #087AA3;
      width: 100%;
      margin-bottom: 1rem;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0.1rem 0.6rem;
      box-sizing: border-box;
  }
  .warning_record>.warning_record_item>span{
      display: flex;
      width: 1rem;
      height: 1rem;
  }
  .warning_record>.warning_record_item>span:nth-child(1){
      position: absolute;
      top: -0.1rem;
      left: -0.1rem;
      border-top:1px solid #00DAFC  ;
      border-left:1px solid #00DAFC  ;
  }
  .warning_record>.warning_record_item>span:nth-child(2){
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      border-top:1px solid #00DAFC  ;
      border-right:1px solid #00DAFC  ;
  }
  .warning_record>.warning_record_item>span:nth-child(3){
      position: absolute;
      bottom: -0.1rem;
      left: -0.1rem;
      border-bottom:1px solid #00DAFC  ;
      border-left:1px solid #00DAFC  ;
  }
  .warning_record>.warning_record_item>span:nth-child(4){
      position: absolute;
      bottom: -0.1rem;
      right: -0.1rem;
      border-bottom:1px solid #00DAFC  ;
      border-right:1px solid #00DAFC  ;
  }
  .warning_record>.warning_record_item>.item_left{
      height: 100%;
      overflow: hidden;
  }
  .warning_record>.warning_record_item>.item_left>i{
      color: #00DAFC ;
      display: inline-block;
      margin-right: 0.8rem;
  }
  .warning_record>.warning_record_item>.item_left>span{
      font-size: 14px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #FFFFFF;
  }
  .warning_record>.warning_record_item>.item_right{
  
      font-size: 14px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #00DAFC;
  
  }
  /* 右边 */
  .warning_inner_right{
      /* width: 78%; */
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.3);
      border: 1px solid #0386A2;
      padding: 2rem 1rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      border: solid 1px #0386a2;
      clip-path: polygon(15px 0, calc(100% - 15px) 0,100% 15px, 100% calc(100% - 15px),
                      calc(100% - 15px) 100%, 15px 100%,0 calc(100% - 15px),0 15px);
      background:linear-gradient(-45deg,#0386a2 10px, #001420 0) bottom right,
                 linear-gradient(45deg,#0386a2 10px, #001420 0) bottom left,
                 linear-gradient(135deg,#0386a2 10px, #001420 0) top left,
                 linear-gradient(-135deg,#0386a2 10px,#001420 0) top right; 
     background-size: 50% 50%; 
     background-repeat: no-repeat; 
  
  }
      /* 下拉选择框以及提交按钮 */
  .top_select{
      width: 100%;
      height: 18%;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      padding: 1rem 1.5rem 1rem 1.5rem;
      box-sizing: border-box;
      width: 100%;
      border: solid 1px #0386a2;
      clip-path: polygon(15px 0, calc(100% - 15px) 0,100% 15px, 100% calc(100% - 15px),
                      calc(100% - 15px) 100%, 15px 100%,0 calc(100% - 15px),0 15px);
      background:linear-gradient(-45deg,#0386a2 10px, #001420 0) bottom right,
                 linear-gradient(45deg,#0386a2 10px, #001420 0) bottom left,
                 linear-gradient(135deg,#0386a2 10px, #001420 0) top left,
                 linear-gradient(-135deg,#0386a2 10px,#001420 0) top right; 
      background-size: 50% 50%; 
      background-repeat: no-repeat; 
      display: flex;
      flex-direction: row;
      font-size: 1.4rem;
  }
  .select_item{
      margin-right: 2rem;
      display: flex;
      align-items: center;
  }
  .select_item>label{
    display: flex;
    width: 5.6rem;
    height: 1.7rem;
    
      margin-right: 1rem;
      /* font-size: 14px; */
      font-family: PingFangSC;
      font-weight: 400;
      color: #00DAFC;
  }
  .stationName{
      height: 3.2rem;
      width: 17rem;
  }
  .select_btn{
      width: 15%;
      display: flex;
      align-items: center;
  }
  .select_btn>button{
      width: 9rem;
      height: 3.4rem;
      background: url(../../assets/images/iems/one_menu_bag.png) no-repeat center/100% 100%;
      font-size: 1.4rem;
      font-family: PingFangSC;
      font-weight: 400;
      color: #00DAFC;
      cursor: pointer;
  }
  .select_btn>button>i{
      margin-right: 0.5rem;
  }
  .select_btn>button:hover{
      background: url(../../assets/images/iems/one_menu_bag_sel.png) no-repeat center/100% 100%;
      color: #FDE223;
  }
  .select_btn>button:nth-child(1){
      margin-right: 1.5rem;
  }
  .btn{
      font-size: 1.2rem;
      color: #fff; 
      padding:0.2rem 0.5rem;
      box-sizing: border-box;
      cursor: pointer;
      background-color: #409eff;
      border-radius: 10%;
     
  }
  .btn:nth-child(1){
    margin-right: 1rem;
  }
.btn:hover{
      background-color: #66b1ff;
  
  }
  ::v-deep .el-select__tags>span{
    display: flex;
    white-space: nowrap;
  /*2. 超出的部分隐藏*/
      overflow: hidden;
  /*3. 文字用省略号替代超出的部分*/
      text-overflow: ellipsis;
      
  }
  ::v-deep .el-tag{
    border: none;
    background:none;color: #0bc4f0;
  }
  ::v-deep .el-select .el-tag__close.el-icon-close {
    background:none;
  }
  .pagination_alarm{
    margin: 1rem 0;
  }

  ::v-deep .el-input__inner{
    height: 3.2rem;
  }

  ::v-deep .el-select__tags{
    height: 3.2rem;
    line-height: 3.2rem;
  }
  ::v-deep .el-select__tags span{
    height: 3.2rem;
    line-height: 3.2rem;
    font-size: 1.5rem;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected{
    background:none;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
    background:none;
  }
 
  </style>
  <!-- <style>
     .el-message-box{
    background: url("../../assets/images/control_win_bag_1.png");
    border: none;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .el-message-box__title, .el-message-box__headerbtn, .el-message-box__message{
        color: #00DAFC;
    }
    .el-message-box__btns>.el-button{
        background: none;
        border: none;
        background: url(../../assets/images/one_menu_bag.png) no-repeat center/100% 100%;
        color: #00DAFC;
    }
    .el-message-box__btns>.el-button:hover{
        background: url(../../assets/images/one_menu_bag_sel.png) no-repeat center/100% 100%;
      color: #FDE223;
    }
</style> -->